import React from 'react'


const CommonTitle = ({ heading }) => {

    return (
        <>
            {/* Page Header */}
            <div className="announcement-list-page padding-desktop">
            <div className={`page-header mobile-margin`}>
                <div className="page-title-section">
                    <div className="title-line"></div>
                    <div className="title-content">
                        <h1 className="page-title">{heading}</h1>
                    </div>
                </div>

            </div>
            </div>
        </>
    )
};

export default CommonTitle;




